"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsPartParameterValueModal = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactIntlUniversal = _interopRequireDefault(require("react-intl-universal"));
var _material = require("@mui/material");
var _DmsButton = require("../DmsButton/DmsButton");
var _DmsPartParameterValueTable = require("../DmsPartParameterValue/DmsPartParameterValueTable");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * DmsBatchModal component
 * 
 * @param {object} show - control useState modal
 * @param {object} onHide - control to close a modal
 * @param {object} row_data - data of row in DmsTable
 * @param {string} title - optional parameter to change a title, default is Batches
 */

const DmsPartParameterValueModal = _ref => {
  let {
    show,
    onHide,
    row_data,
    title = _reactIntlUniversal.default.get("PartParameters").d("Part parameters")
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_material.Dialog, {
    open: show,
    onClose: onHide,
    fullWidth: true,
    maxWidth: "lg"
  }, /*#__PURE__*/_react.default.createElement(_material.DialogTitle, null, title), /*#__PURE__*/_react.default.createElement(_material.DialogContent, {
    dividers: true,
    style: {
      maxHeight: '70vh',
      overflowY: 'auto'
    }
  }, /*#__PURE__*/_react.default.createElement(_DmsPartParameterValueTable.DmsPartParameterValueTable, {
    row_pk: row_data.pk
  })), /*#__PURE__*/_react.default.createElement(_material.DialogActions, null, /*#__PURE__*/_react.default.createElement(_DmsButton.DmsButton, {
    onClick: onHide,
    variant: "text",
    color: "primary",
    size: "medium"
  }, _reactIntlUniversal.default.get("Close").d("Close"))));
};
exports.DmsPartParameterValueModal = DmsPartParameterValueModal;